/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Representation of a Search Query
 * @export
 * @interface SearchQuery
 */
export interface SearchQuery {
    /**
     * Value of search query
     * @type {string}
     * @memberof SearchQuery
     */
    value?: string;
}

/**
 * Check if a given object implements the SearchQuery interface.
 */
export function instanceOfSearchQuery(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SearchQueryFromJSON(json: any): SearchQuery {
    return SearchQueryFromJSONTyped(json, false);
}

export function SearchQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchQuery {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function SearchQueryToJSON(value?: SearchQuery | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value,
    };
}

